export const drawerWidth = 240;
export const GA_TRACKING_CODE = "UA-175296999-1";
